// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDeleteModal_root__tXAyv","container":"ConfirmDeleteModal_container__+dWJa"};